import React from 'react';
import logo from 'assets/img/dohwa.png';

export default function Invoice(props) {
  const { estimateInfo } = props;

  const trHeight = { height: '22px' };
  const tdTotalLeftStyle = { width: '600px', textAlign: 'right', fontWeight: 'bold' };
  const tdTotalRightStyle = { width: '200px', textAlign: 'right' };

  function leftPad(value) {
    if (value >= 10) {
      return value;
    }
    return `0${value}`;
  }

  function toStringByFormatting(source, delimiter = '-') {
    const year = source.getFullYear();
    const month = leftPad(source.getMonth() + 1);
    const day = leftPad(source.getDate());
    return [year, month, day].join(delimiter);
  }

  return (
    <div id="page" className="page a4">
      <div style={{ position: 'relative', marginTop: '30px' }}>
        <img src={logo} width="200px" style={{ position: 'absolute' }} />
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td style={{ width: '100%', textAlign: 'right' }}>
                <strong>제공 : (주)도화엔지니어링</strong>
              </td>
            </tr>
            <tr>
              <td style={{ width: '100%', textAlign: 'right' }}>서울시 강남구 삼성로 438(대치동)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <table style={{ float: 'left', fontWeight: 'bold', width: '100%', marginTop: '60px', marginBottom: '30px' }}>
        <tbody>
          <tr>
            <td style={{ width: '100%', textAlign: 'center' }}>
              <h1>견적서</h1>
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: '100%', height: '110px' }}>
        <tbody>
          <tr style={trHeight}>
            <td style={{ width: '70%', height: '22px' }}>
              <strong>상세 사항</strong>
            </td>
            <td style={{ width: '30%', height: '22px', textAlign: 'left' }}>
              <strong>수취인</strong>
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}>견적일자 : {toStringByFormatting(new Date())}</td>
            <td style={{ width: '30%', textAlign: 'left' }}>{estimateInfo?.companyName}</td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}>견적 유효기간 : 견적일로부터 10일</td>
            <td style={{ width: '30%', textAlign: 'left' }}>{estimateInfo?.companyNo}</td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}></td>
            <td style={{ width: '30%', textAlign: 'left' }}>
              {estimateInfo?.userid}({estimateInfo?.username})
            </td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}></td>
            <td style={{ width: '30%', textAlign: 'left' }}>{estimateInfo?.cellPhoneNumber}</td>
          </tr>
          <tr style={trHeight}>
            <td style={{ width: '70%' }}></td>
            <td style={{ width: '30%', textAlign: 'left' }}>{estimateInfo?.eMail}</td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: '100%', marginTop: '70px', border: 'solid 1px gray' }}>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '30%' }} />
          <col style={{ width: '40%' }} />
        </colgroup>
        <tbody>
          <tr style={{ backgroundColor: 'gray', color: 'white' }}>
            <th>품명</th>
            <th>수량</th>
            <th>금액</th>
          </tr>
          <tr>
            <td style={{ textAlign: 'center' }}>쿠폰</td>
            <td style={{ textAlign: 'right' }}>{estimateInfo?.quantity}장</td>
            <td style={{ textAlign: 'right' }}>{estimateInfo?.totalAmount}원</td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: '100%', marginTop: '70px' }}>
        <tbody>
          {/*<tr>*/}
          {/*  <td style={tdTotalLeftStyle}>쿠폰 금액 :</td>*/}
          {/*  <td style={tdTotalRightStyle}>*/}
          {/*    <CustomInput isTextField={isTextField} id="totalAmount" value={estimateInfo?.totalAmount} label="TOTAL_AMOUNT" unit="원" style={{ width: '80%' }} />*/}
          {/*  </td>*/}
          {/*</tr>*/}
          {/*<tr>*/}
          {/*  <td style={tdTotalLeftStyle}>할인 금액 :</td>*/}
          {/*  <td style={tdTotalRightStyle}>*/}
          {/*    {isTextField ? (*/}
          {/*      <CustomInput isTextField={isTextField} id="discountAmount" value={estimateInfo?.discountAmount} label="DISCOUNT_AMOUNT" unit="원" style={{ width: '80%' }} />*/}
          {/*    ) : !isNaN(estimateInfo?.discountAmount) || estimateInfo?.discountAmount ? (*/}
          {/*      `${estimateInfo?.discountAmount} 원`*/}
          {/*    ) : (*/}
          {/*      'DISCOUNT_AMOUNT 원'*/}
          {/*    )}*/}
          {/*  </td>*/}
          {/*</tr>*/}
          <tr>
            <td style={tdTotalLeftStyle}>공급가액 :</td>
            <td style={tdTotalRightStyle}>{estimateInfo?.sumAmount}원</td>
          </tr>
          <tr>
            <td style={tdTotalLeftStyle}>부가세 :</td>
            <td style={tdTotalRightStyle}>{estimateInfo?.vatAmount}원</td>
          </tr>
          <tr>
            <td style={tdTotalLeftStyle}>최종 결제 금액 :</td>
            <td style={tdTotalRightStyle}>{estimateInfo?.depositAmount}원</td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <p style={{ fontSize: 'smaller' }}>문의사항은 swmaster@dohwa.co.kr으로 보내주시면 답변드리겠습니다.</p>
    </div>
  );
}
